export default "__VITE_ASSET__CaK3pYl8__"